import type { EmotionJSX } from "@emotion/react/dist/declarations/src/jsx-namespace";
import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { contentMostPopularTagContent$key } from "scmp-app/queries/__generated__/contentMostPopularTagContent.graphql";

import { useGetMostPopularArticlesData } from "./hooks";
import { Container } from "./styles";
import type { MostPopularArticlesData } from "./types";

const getRankingInfo = (data: MostPopularArticlesData, entityId: string) => {
  const globalRanking = data?.global?.indexOf(entityId) ?? -1;
  if (globalRanking !== -1) {
    return { location: "globally", ranking: globalRanking + 1 };
  }

  const hkRanking = data?.hk?.indexOf(entityId) ?? -1;
  if (hkRanking !== -1) {
    return { location: "in Hong Kong", ranking: hkRanking + 1 };
  }

  return { location: null, ranking: null };
};

type Props = {
  className?: string;
  fallback?: EmotionJSX.Element | null | undefined;
  reference: contentMostPopularTagContent$key;
};

const Component: FunctionComponent<Props> = ({ className, fallback, reference }) => {
  const content = useFragment(
    graphql`
      fragment contentMostPopularTagContent on Article {
        entityId
      }
    `,
    reference,
  );
  const data = useGetMostPopularArticlesData();

  const { location, ranking } = getRankingInfo(data, content.entityId);

  if (!ranking) return <>{fallback}</>;

  return (
    <Container className={className}>
      #{ranking} Most Read {location}
    </Container>
  );
};

Component.displayName = "ContentMostPopularTag";

export const ContentMostPopularTag = Component;
